/* eslint-disable */
import React from 'react';
import { Button, Modal, Col } from 'react-bootstrap';
import { Wrench, PlusLg, Trash, ChevronLeft } from 'react-bootstrap-icons';
import RepeatTool from './RepeatTool';

class ToolsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showRepeatTool: false,
      showMenu: true,
      showUndoTool: false,
    };
  }

  toggleModal = () => this.setState({ showModal: !this.state.showModal });
  toggleRepeatTool = () => this.setState({
    showRepeatTool: !this.state.showRepeatTool,
    showMenu: !this.state.showMenu,
  });
  toggleUndoTool = () => this.setState({
    showUndoTool: !this.state.showUndoTool,
    showMenu: !this.state.showMenu,
  });

  render() {
    return (
      <div className="tools">
        <Button variant="light" onClick={this.toggleModal}>
          <Wrench />
        </Button>
        <Modal show={this.state.showModal} onHide={this.toggleModal}>
          <Modal.Header closeButton>
            {this.state.showMenu && <Modal.Title>Advanced Tools</Modal.Title>}
            {this.state.showRepeatTool && <Modal.Title>Repeat Tool</Modal.Title>}
            {this.state.showUndoTool && <Modal.Title>Undo Tool</Modal.Title>}
          </Modal.Header>
          <Modal.Body>
            {this.state.showMenu && (
              <div className="menu">
                <Col lg={6} md={6} className="advancedTool">
                  <Button className="w-100" variant="primary" size="lg" onClick={this.toggleRepeatTool}>
                    <PlusLg /><PlusLg /><PlusLg />
                  </Button>
                  <h4 className="text-center">Repeat this change on other sites</h4>
                </Col>
                <Col lg={6} md={6} className="advancedTool">
                  <Button className="w-100" variant="primary" size="lg" onClick={this.toggleUndoTool}>
                    <Trash />
                  </Button>
                  <h4 className="text-center">Undo this change</h4>
                </Col>
                <div className="clearfix" />
              </div>
            )}
            {this.state.showRepeatTool && (
              <RepeatTool callDVS={this.props.callDVS} diff={this.props.diff} undo={false} />
            )}
            {this.state.showUndoTool && (
              <RepeatTool callDVS={this.props.callDVS} diff={this.props.diff} undo />
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.showRepeatTool && (
              <Button className="backButton" variant="light" onClick={this.toggleRepeatTool}>
                <ChevronLeft />back
              </Button>
            )}
            {this.state.showUndoTool && (
              <Button className="backButton" variant="light" onClick={this.toggleUndoTool}>
                <ChevronLeft />back
              </Button>
            )}
            <Button onClick={this.toggleModal}>close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ToolsView;
